import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useAsyncFn } from 'react-use/lib';
import { addAbsoluteUrlsToUrlDescriptions, contentToEnvelope } from 'libs/content/utils';
import { getFirstLoadContent } from 'redux/content';
import { generateUrls } from 'services/networking/navigation';

var useGenerateUrls = function useGenerateUrls() {
  var _useSelector = useSelector(getFirstLoadContent),
      firstLoadContent = _useSelector.value;

  var _useFormContext = useFormContext(),
      getValues = _useFormContext.getValues;

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(firstLoadContent === undefined)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return generateUrls(contentToEnvelope(_objectSpread(_objectSpread({}, firstLoadContent), {}, {
              contentData: getValues()
            })));

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [firstLoadContent, getValues]),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      _useAsyncFn2$ = _useAsyncFn2[0],
      loading = _useAsyncFn2$.loading,
      value = _useAsyncFn2$.value,
      doGenerateUrls = _useAsyncFn2[1];

  var urls = addAbsoluteUrlsToUrlDescriptions(value !== null && value !== void 0 ? value : []);
  return {
    loading: loading,
    urls: urls,
    doGenerateUrls: doGenerateUrls
  };
};

export default useGenerateUrls;